import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function Contact() {
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <section className="container py-3">
        <div className="row min-vh-75">
          <div className="col-lg-6 col-md-12 col-12 d-flex align-items-center">
            <div className="py-8 me-xl-8 pe-xl-8">
              <div className="d-flex justify-content-between mb-4 align-items-center">
                <div className="form-check form-switch theme-switch d-none">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexSwitchCheckDefault"
                  />
                </div>
              </div>
              <div>
                <h1 className="display-5 fw-semibold text-white">
                  Get In Touch.
                </h1>
                <p className="lead text-white lh-sm">
                  Fill in the form and say hello. Someone from our team will get
                  back to you quickly, usually with a smile.
                </p>
                <div className="mt-6 fs-4">
                  <p className="mb-4 lh-sm">
                    For any queries or support, please contact us at{" "}
                    <a
                      href="mailto:support@visualaey.com"
                      className="text-primary"
                    >
                      support@visualaey.com
                    </a>
                    .
                  </p>
                  <p className="mb-1 text-white">
                    <i className="bi bi-telephone text-primary me-2" />
                    +91 9619359359
                  </p>
                  <p className="mb-1 text-white">
                    <i className="bi bi-envelope-open text-primary me-2" />
                    contact@visualaey.com
                  </p>
                  <p className="mb-1 text-white">
                    <i className="bi bi-geo-alt text-primary me-2" />
                    1101 Padmavati Heights, Vile Parle (E), Mumbai – 400057
                  </p>
                </div>
                <div className="mt-8">
                  <a
                    href="https://www.facebook.com/share/1Ej8ZsML3e/?mibextid=wwXIfr"
                    target="_blank"
                  >
                    <i className="bi bi-facebook text-light fs-4 me-3"></i>
                  </a>
                  <a href="https://www.instagram.com/visualaey" target="_blank">
                    <i className="bi bi-instagram text-light fs-4 me-3"></i>
                  </a>
                  <a href="https://www.x.com/visualaey" target="_blank">
                    <i className="bi bi-twitter-x text-light fs-4"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-lg-flex align-items-center w-lg-50 position-fixed-lg bg-cover bg-white top-0 right-0 rounded-5">
            <div className="px-4 px-xl-2 mx-xl-5 py-8 py-lg-0">
              <div>
                <form className="row g-2 needs-validation" noValidate="">
                  <div className="mb-1 col-12">
                    <label className="form-label" htmlFor="fname">
                      Full Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control bg-white rounded-3"
                      type="text"
                      name="last name"
                      placeholder="Enter Full Name"
                      required=""
                    />
                  </div>
                  <div className="mb-1 col-12 col-md-6">
                    <label className="form-label" htmlFor="email">
                      Email ID <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control bg-white rounded-3"
                      type="email"
                      placeholder="Enter Email"
                      required=""
                    />
                  </div>
                  <div className="mb-1 col-12 col-md-6">
                    <label className="form-label" htmlFor="phone">
                      Phone No. <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control bg-white rounded-3"
                      type="text"
                      name="phone"
                      placeholder="Enter Phone"
                      required=""
                    />
                  </div>
                  <div className="mb-1 col-12">
                    <label
                      className="text-dark form-label"
                      htmlFor="contactReason"
                    >
                      Subject / Reason <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control bg-white rounded-3"
                      type="text"
                      name="reason"
                      placeholder="Enter Subject / Reason"
                      required=""
                    />
                  </div>
                  <div className="mb-2 col-12">
                    <label className="text-dark form-label" htmlFor="messages">
                      Message
                    </label>
                    <textarea
                      className="form-control bg-white rounded-3"
                      rows={3}
                      placeholder="Enter Message"
                      defaultValue={""}
                    />
                  </div>
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-primary px-5 rounded-pill"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-lg-6 pb-lg-3 py-5">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
              <img
                src="/assets/images/11.jpg"
                class="object-fit-cover w-100 rounded-5"
                height="400"
              />
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <div class="ps-lg-6">
                <span className="badge bg-white-soft rounded-pill fs-5 px-4 mb-2">
                  Face Matching That Works{" "}
                  <span className="fw-bold">Like Magic</span>
                </span>
                <h1 class="display-5 text-light fw-bold my-3 ls-sm lh-1">
                  Let Every Guest Find Their Moments Instantly
                </h1>
                <p class="mb-3 h3 lh-1 text-light fw-normal opacity-75">
                  Whether you're hosting a wedding, birthday, corporate event,
                  or reunion, our clever AI matches your face across thousands
                  of high resolution photos and delivers every memory you're in,
                  straight to your private gallery, in seconds. No tagging, no
                  searching, no effort. Just moments that find you instantly.
                </p>
                <div class="mt-3">
                  <div class="mb-2">
                    <div>
                      <p class="mb-3 fs-4 lh-sm text-white opacity-50">
                        Our platform identifies individual faces across
                        thousands of high-resolution photos, matching guests
                        with their captured memories in seconds.
                      </p>
                    </div>
                  </div>
                </div>
                <Link
                  to="/book-demo"
                  class="btn btn-white px-5 btn-md mt-3 mb-lg-0 mb-5"
                >
                  Book a Demo
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Contact;
